import { create } from 'zustand';

const useUiStore = create((set) => ({
  isUpgradeModalOpen: false,
  openUpgradeModal: () => set({ isUpgradeModalOpen: true }),
  closeUpgradeModal: () => set({ isUpgradeModalOpen: false }),
}));

export default useUiStore;
